import React, { Component, } from "react";
import axios from "axios";

export default class PDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfResponseUrl: ""
    };

    this.changeRoute = this.changeRoute.bind(this);
  }

  changeRoute(route){
    this.props.history.push(route);
  }

  async componentDidMount(){
    const searchParams = this.props.match.params.x;

    try {
      const requestUrl = `https://api.foundersportgroup.com/api/catalogs/archived-playbooks/lookup/${searchParams}.pdf`;
      const { data, data: { url } } = await axios.get(requestUrl);

      if(data){
        const pdfUrl = `https:${url}`;
        
        this.setState = {
          pdfResponseUrl: pdfUrl
        };
        window.location.replace(pdfUrl);
      } else {
        this.changeRoute(searchParams);
      }
    } catch (err){
      this.changeRoute("/");
    }
  }

  render() {
    return (
      <a href={this.state.pdfResponseUrl}>
        view pdf
        {/* // this is necessary for react unless we want to remove class component and do a refactor */}
      </a>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Pdf/Pdf.js